import { render, staticRenderFns } from "./HollyFiSideBar.vue?vue&type=template&id=6d9e731e&scoped=true&"
import script from "./HollyFiSideBar.vue?vue&type=script&lang=js&"
export * from "./HollyFiSideBar.vue?vue&type=script&lang=js&"
import style0 from "./HollyFiSideBar.vue?vue&type=style&index=0&id=6d9e731e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e731e",
  null
  
)

export default component.exports